module.exports = __webpack_public_path__ + "static/media/ipad_10_9_inch_air_space_grey.8f8e95da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/iphone/ipad_10_9_inch_air_space_grey.png
// module id = 2105
// module chunks = 0